import axios from "axios";
import config from "../../config/config";
import store from "../../store/store.js";

const axiosInstance = axios.create({
	baseURL: config.Urls.BaseUrl,
	headers: {
		"Content-Type": "application/json",
	},
});

axiosInstance.interceptors.request.use(
	async (config) => {
		const state = store.getState();
		const token = state.auth.accessToken;
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export default axiosInstance;
